import React, { useEffect } from "react";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import RichFileSelector from "../../../RichFileSelector/RichFileSelector";
import { useTranslation } from 'react-i18next';


/**
 * @Description this page Active Directory  Library's Move User  Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function MoveUser({
  action,
  variables,
  setOpenVariable,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.MOVE-USER.";

  useEffect(() => {
    if (!action.fields.oldDn) {
      action.fields.oldDn = { value: '', isRequired: true }
    }
    if (!action.fields.newDn) {
      action.fields.newDn = { value: '', isRequired: true }
    }
  }, [action.fields]);

  return (
    <div>
      <div className="form-element">
        {t(label + "USER-LDAP-PATH")}
        <TextInput
          action={action}
          inputName="oldDn"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          fieldType="string"
          displayName={t(label + "USER-LDAP-PATH")}
        />
        <small>cn=test,cn=Users,dc=autommate,dc=com</small>
      </div>
      <div className="form-element">
        {t(label + "MOVE-TO")}
        <TextInput
          action={action}
          inputName="newDn"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          fieldType="string"
          displayName={t(label + "MOVE-TO")}
        />
        <small>ou=istanbul,dc=autommate,dc=com</small>
        <RichFileSelector action={action} variables={variables} setOpenVariable={setOpenVariable} />
      </div>
    </div>
  );
}
